import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MapZoomToRoute } from "@/utils";
import { Map, MapControls, MapMarker, MapRoute, MarkerContent, MarkerTooltip, } from "../ui/map";
export function MapaDeRotas({ mapCenterCoordinates, zoom, selectedRoute, onSelectRoute, routes, }) {
    return (_jsx("div", { className: "relative h-full w-full", children: _jsxs(Map, { className: "overflow-hidden", center: mapCenterCoordinates, zoom: zoom ?? 6, theme: "light", styles: {
                light: "https://tiles.openfreemap.org/styles/bright",
                dark: "",
            }, children: [_jsx(MapZoomToRoute, { selectedRoute: selectedRoute }), routes.map((route) => {
                    const start = route.municipioPartida?.longitude != null &&
                        route.municipioPartida?.latitude != null
                        ? [
                            route.municipioPartida.longitude,
                            route.municipioPartida.latitude,
                        ]
                        : null;
                    const end = route.municipioDestino?.latitude != null &&
                        route.municipioDestino?.longitude != null
                        ? [
                            route.municipioDestino.longitude,
                            route.municipioDestino.latitude,
                        ]
                        : null;
                    const coordinates = start && end ? [start, end] : [];
                    if (!start || !end)
                        return null;
                    const routeColor = route.status === "INATIVO" ? "#7C7C7C" : "#3b82f6";
                    const routeOpacity = route.status === "INATIVO" ? 0.6 : 1;
                    return (_jsxs("div", { children: [_jsx(MapRoute, { coordinates: coordinates, color: routeColor, width: selectedRoute?.id === route.id ? 6 : 4, opacity: routeOpacity, onClick: () => onSelectRoute(route) }), _jsxs(MapMarker, { longitude: start[0], latitude: start[1], children: [_jsx(MarkerContent, { children: _jsx("div", { className: "size-4 rounded-full border-2 border-white bg-white shadow" }) }), _jsx(MarkerTooltip, { children: route.municipioPartida?.nome })] }), _jsxs(MapMarker, { longitude: end[0], latitude: end[1], children: [_jsx(MarkerContent, { children: _jsx("div", { className: "size-4 rounded-full border-2 border-white bg-white shadow" }) }), _jsx(MarkerTooltip, { children: route.municipioDestino?.nome })] })] }, route.id));
                }), _jsx(MapControls, {})] }) }));
}
